import React from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { pushState } from './Settings';
import { setReturnTo } from '../utils/sessionUtils';
import cofre112v2 from './images/cofre112v2.png';
import biruxComodin112 from './images/biruxComodin112.png';

// Sin imagen subida desde el panel, la de la Overbox de siempre.
const imagen = (codigo) => codigo.image ? '/images/rewards/' + codigo.image : cofre112v2;

// Lo que se pregunta al volver de abrir un codigo, segun lo que falte: 'registro' si no tiene
// sesion, 'cuenta' si no tiene encendidos los avisos de codigos, 'dispositivo' si los tiene pero
// este navegador aun no ha dado el permiso (los activo en otro).
const PREGUNTAS = {
    registro: '¿Quieres que te avisemos de los próximos códigos? Inicia sesión en la web y activa las notificaciones.',
    cuenta: '¿Quieres activar las notificaciones para que te avisemos de los próximos códigos?',
    dispositivo: 'En otro dispositivo ya tienes activadas las notificaciones. ¿Quieres activarlas aquí también?'
};
const ASKED_KEY = 'avisoCodigosPreguntado:';
// El codigo se abre en otra pestaña o, en los navegadores de dentro de Twitch, YouTube o Discord,
// en esta misma, que al volver se carga de nuevo y pierde todo: por eso va en sessionStorage.
const ABIERTO_KEY = 'codigoAbierto';

const Codigos = ({ setIsDropped, setOverInfo, isAuthenticated, loading }) => {
    const [codigos, setCodigos] = React.useState(null);
    // Icono del boton de "Consigue más premios": la imagen del Pase Plus de la tienda.
    const [pase, setPase] = React.useState(null);
    // Con sesion, el boton solo sale si aun le toca el Tutorial (activo: false si ya lo hizo).
    const [tutorialPendiente, setTutorialPendiente] = React.useState(false);
    const { code } = useParams();
    const navigate = useNavigate();
    // Se pregunta al volver a esta pestaña, no encima del click.
    React.useEffect(() => {
        const alVolver = async () => {
            if (document.visibilityState !== 'visible' || !sessionStorage.getItem(ABIERTO_KEY)) return;
            sessionStorage.removeItem(ABIERTO_KEY);
            try {
                const data = await (await fetch('/api/settings', { credentials: 'include' })).json();
                const pregunta = data.error === 'not_authenticated' ? 'registro'
                    : !data.success ? null
                        : !data.notifications.codes ? 'cuenta' : pushState() === 'default' ? 'dispositivo' : null;
                // ponytail: cada pregunta se hace una vez por navegador, no por cuenta: quien diga que
                // no en un dispositivo la vera otra vez en el siguiente. Guardarlo en el usuario si molesta.
                if (!pregunta || localStorage.getItem(ASKED_KEY + pregunta)) return;
                localStorage.setItem(ASKED_KEY + pregunta, '1');
                setOverInfo({
                    title: 'Notificaciones',
                    description: PREGUNTAS[pregunta],
                    button: () => {
                        setIsDropped(false);
                        // Tras conectarse vuelve directo a Ajustes (loginOnProgress)
                        if (pregunta === 'registro') setReturnTo('/myAccount/settings');
                        navigate(pregunta === 'registro' ? '/myAccount' : '/myAccount/settings');
                    },
                    buttonText: <><h3>{pregunta === 'registro' ? 'Iniciar sesión' : 'Sí, activar'}</h3></>
                });
                setIsDropped(true);
            } catch (e) { }
        };
        // Al montar: volvio en la misma pestaña y la pagina se ha cargado de nuevo.
        alVolver();
        document.addEventListener('visibilitychange', alVolver);
        window.addEventListener('pageshow', alVolver);
        return () => {
            document.removeEventListener('visibilitychange', alVolver);
            window.removeEventListener('pageshow', alVolver);
        };
    }, [navigate, setIsDropped, setOverInfo]);

    React.useEffect(() => {
        fetch('/api/codigos', { method: 'POST' })
            .then(res => res.json())
            .then(data => setCodigos(Array.isArray(data) ? data : []))
            .catch(() => setCodigos([]));
        fetch('/api/rewards?search=pase%20plus', { method: 'POST' })
            .then(res => res.json())
            .then(data => setPase(Array.isArray(data) ? data.find(r => r.image)?.image : null))
            .catch(() => { });
    }, []);

    React.useEffect(() => {
        if (!isAuthenticated) return;
        fetch('/api/tutorial', { credentials: 'include' })
            .then(res => res.json())
            .then(data => setTutorialPendiente(!!data.activo))
            .catch(() => { });
    }, [isAuthenticated]);

    // Al elegir otro de la lista de abajo, el destacado cambia arriba del todo.
    React.useEffect(() => { window.scrollTo(0, 0); }, [code]);

    if (!codigos) {
        return (
            <div className="topCommands info page codigosPage">
                <div className='preSpinner'><div className='spinner'></div></div>
            </div>
        );
    }

    // Destacado: el del enlace (lo que sueltan los comandos del chat) o, si no, el primero, que es
    // el marcado como destacado en el panel o, sin ninguno, el mas nuevo. Los caducados van al
    // final y solo salen arriba si se llega por su enlace.
    const destacado = codigos.find(codigo => codigo.key === code) || codigos.find(codigo => !codigo.expired);
    const resto = codigos.filter(codigo => codigo !== destacado);
    // Caducado: se ve igual pero no es un enlace.
    const Tarjeta = destacado && destacado.expired ? 'div' : 'a';

    return (
        <div className="topCommands info page codigosPage">
            <h2 className='heroes'>Código destacado</h2>
            {!destacado
                ? <div className='heroes'>Ahora mismo no hay ningún código activo, ¡vuelve pronto!</div>
                : <Tarjeta className={'infoBox' + (destacado.expired ? ' caducado' : '')}
                    {...(destacado.expired ? {} : { href: destacado.url, target: '_blank', rel: 'noopener noreferrer', onClick: () => sessionStorage.setItem(ABIERTO_KEY, '1') })}>
                    <div>
                        <img src={imagen(destacado)} alt={destacado.title} />
                        <div className='heroes'>
                            {destacado.expired ? <span className='caducadoTag'>Caducado</span> : null}
                            <h3 className='name'>{destacado.title}</h3>
                            <div className='description'>{destacado.description}</div>
                        </div>
                    </div>
                </Tarjeta>}
            {/* A la home, donde sale la Bienvenida (sin sesion) o el Tutorial (con sesion): con premios,
                aunque ya la hubiera cerrado ("Más tarde" o haber entrado antes en el login). */}
            {!loading && (!isAuthenticated || tutorialPendiente) ? (
                <Link className='codigosMas' to='/' state={{ premios: true }}>
                    <img src={pase ? '/images/rewards/' + pase : biruxComodin112} alt='' />
                    Consigue más premios
                </Link>
            ) : null}
            {resto.length > 0 ? (
                <>
                    <h2 className='heroes'>Más códigos</h2>
                    <div className='codigosList heroes'>
                        {resto.map(codigo => (
                            <Link key={codigo.key} to={'/codigos/' + encodeURIComponent(codigo.key)} className={codigo.expired ? 'caducado' : undefined}>
                                <img src={imagen(codigo)} alt='' />
                                <span>{codigo.title}</span>
                                {codigo.expired ? <span className='caducadoTag'>Caducado</span> : null}
                            </Link>
                        ))}
                    </div>
                </>
            ) : null}
        </div>
    );
}
export default Codigos
